import {Box, Breadcrumb, BreadcrumbItem, BreadcrumbLink, Container, Flex, Grid, Text} from '@chakra-ui/react';

import {ChevronRightIcon} from "@chakra-ui/icons";
import {MyHeading} from "../MyChackra/MyHeading"

import Image from "next/image"

import styles from "../../../styles/components/VictoryDetail.module.css"
import NextLink from "next/link";
import {VictoryShareButtons} from "../VictoryShareButtons";

export function VictoryDetail(props) {
    const {
        content,
        hashtags,
        slug,
        social_description,
        thumbnail_placeholder,
        thumbnail_url,
        title,
        victory_at
    } = props

    return <>
        <Container
            maxW="800px"
            mt="3rem"
        >
            <Box>
                <Breadcrumb spacing={1} mb="1rem" separator={<ChevronRightIcon color="gray.500"/>}>
                    <BreadcrumbItem>
                        <NextLink href={"/"} passHref>
                            <BreadcrumbLink>Início</BreadcrumbLink>
                        </NextLink>
                    </BreadcrumbItem>
                    <BreadcrumbItem>
                        <NextLink href={"/vitorias"} passHref>
                            <BreadcrumbLink>Vitórias</BreadcrumbLink>
                        </NextLink>
                    </BreadcrumbItem>
                    <BreadcrumbItem isCurrentPage>
                        <BreadcrumbLink href="#">Essa vitória</BreadcrumbLink>
                    </BreadcrumbItem>
                </Breadcrumb>
            </Box>
            <main>
                <Box textAlign={"right"}>
                    <Image
                        src={thumbnail_url}
                        width={1090}
                        height={600}
                        alt={`Capa da vitória: ${title}`}
                        placeholder={"blur"}
                        blurDataURL={thumbnail_placeholder}
                        layout={"responsive"}
                    />
                    <Text mt={"0.5rem"} fontSize={"xl"}>{victory_at}</Text>
                </Box>
                <Box
                    mt="2rem"
                    alignItems="flex-end"
                    className={styles.VictoryHeader}
                >
                    <MyHeading
                        as="h2"
                        fontSize="180%"
                        w="100%"
                        textAlign="center"
                        textTransform="normal"
                        className={styles.VictoryTitle}
                    >
                        {title}
                    </MyHeading>
                </Box>
                <Flex
                    mt="1rem"
                    flexDirection="row"
                    justifyContent="space-between"
                >
                    <Box
                        fontFamily={"Roboto"}
                        fontWeight={"400"}
                        lineHeight={"1.2"}
                        fontSize={"xl"}
                        textAlign={"justify"}
                        className={styles.VictoryContent}
                    >
                        <Box dangerouslySetInnerHTML={{__html: content}}/>
                        <Box mt={16} w={"100%"}>
                            <Grid
                                templateColumns="repeat(6, 1fr)"
                                gap={1}
                                maxW="200px"
                                m={"0 auto"}
                            >
                                <VictoryShareButtons
                                    data={{
                                        "hashtags": hashtags,
                                        "social_description": social_description,
                                        "slug": slug,
                                    }}
                                />
                            </Grid>
                        </Box>
                    </Box>
                </Flex>
            </main>
        </Container>
    </>
}